import React from 'react';
import { useTranslation } from 'react-i18next';
import './Activities.css';

const divingCenters = [
    { name: 'El Naranjito' },
    { name: 'Planeta Azul' },
    { name: 'Club Islas Hormigas Balkysub' },
    { name: 'Divers' },
];

const hikingRoutes = [
    { name: 'SENDERO CALA REONA – MIRADOR DE PUNTA NEGRA' },
    { name: 'LA MANGA CARTAGENA' },
    { name: 'P.R. Calblanque' },
    { name: 'SENDERO MIRADOR DE PUNTA NEGRA – PLAYA LARGA' },
    { name: 'SENDERO PLAYA LARGA – CALA DEL BARCO' },
    { name: 'SENDERO MONTE DE LAS CENIZAS – PORTMÁN' },
];

const acuaticActivities = [
    { name: 'Kayak' },
    { name: 'Paddle Surf' },
    { name: 'Motos de agua' }
];

const Activities = () => {
    const { t } = useTranslation();

    return (
        <section id="activities">
            <h2>{t('activities')}</h2>

            <div className="activities-container">
                <div className="activity">
                    <div className="activity-icon">🤿</div>
                    <h3>{t('buceo_title')}</h3>
                    <p>{t('buceo_description')}</p>
                    <h4>{t('buceo_centers_title')}</h4>
                    <ul>
                        {divingCenters.map((center, index) => (
                            <li key={index}>{center.name}</li>
                        ))}
                    </ul>
                </div>

                <div className="activity">
                    <div className="activity-icon">🛶</div>
                    <h3>{t('kayak_title')}</h3>
                    <ul>
                        {acuaticActivities.map((route, index) => (
                            <li key={index}>{route.name}</li>
                        ))}
                    </ul>
                </div>

                <div className="activity">
                    <div className="activity-icon">⛳</div>
                    <h3>{t('golf_title')}</h3>
                    <p>{t('golf_description')}</p>
                </div>

                <div className="activity">
                    <div className="activity-icon">🥾</div>
                    <h3>{t('senderismo_title')}</h3>
                    <ul>
                        {hikingRoutes.map((route, index) => (
                            <li key={index}>{route.name}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default Activities;
